const arrowLeft = '<span class="text-xl text-black -translate-y-0.5 inline-block">&lsaquo;</span>';
const arrowRight = '<span class="text-xl text-black -translate-y-0.5 inline-block">&rsaquo;</span>';

const initResponsiveTables = () => {
	const tables = document.querySelectorAll('.text table');

	tables.forEach((table) => {
		let existingContainer = table.closest('.responsive-table-container');

		// Remove previous instance if exists
		if (existingContainer) {
			existingContainer.replaceWith(table);
		}

		let container = document.createElement('div');
		container.classList.add('w-full', 'my-8', 'relative', 'responsive-table-container');

		let wrapper = document.createElement('div');
		wrapper.classList.add('overflow-auto', 'max-w-full', 'w-full');
		table.parentNode.insertBefore(wrapper, table);
		wrapper.appendChild(table);

		wrapper.parentNode.insertBefore(container, wrapper);
		container.appendChild(wrapper);

		// Add scrollbar only if content overflows
		if (wrapper.scrollWidth > wrapper.offsetWidth) {
			let scrollBar = document.createElement('div');
			let scrollProgress = document.createElement('div');
			let btnRight = document.createElement('button');
			let btnLeft = document.createElement('button');

			scrollBar.classList.add('w-full', 'h-1', 'mb-8', 'bg-gray-light', 'shadow', 'sticky');
			scrollProgress.classList.add('absolute', 'top-0', 'left-0', 'h-full', 'bg-black', 'z-0', 'max-w-full');
			scrollProgress.style.width = (wrapper.scrollLeft / (wrapper.scrollWidth - wrapper.offsetWidth)) * 100 + '%';

			btnLeft.classList.add(
				'bg-gray-light',
				'rounded-full',
				'shadow',
				'p-2',
				'z-10',
				'absolute',
				'top-1/2',
				'-translate-y-1/2',
				'left-0',
				'touch-manipulation',
				'size-12'
			);
			btnLeft.innerHTML = arrowLeft;
			btnRight.classList.add(
				'bg-gray-light',
				'rounded-full',
				'shadow',
				'p-2',
				'z-10',
				'absolute',
				'top-1/2',
				'-translate-y-1/2',
				'right-0',
				'touch-manipulation',
				'size-12'
			);
			btnRight.innerHTML = arrowRight;

			scrollBar.appendChild(btnLeft);
			scrollBar.appendChild(scrollProgress);
			scrollBar.appendChild(btnRight);

			container.prepend(scrollBar);

			wrapper.addEventListener('scroll', () => {
				scrollProgress.style.width =
					(wrapper.scrollLeft / (wrapper.scrollWidth - wrapper.offsetWidth)) * 100 + '%';
			});

			btnLeft.addEventListener('click', () => {
				if (wrapper.scrollLeft > 0) {
					wrapper.scrollLeft -= ((wrapper.scrollWidth - wrapper.offsetWidth) / 100) * 20;
				}
			});

			btnRight.addEventListener('click', () => {
				if (wrapper.scrollLeft < wrapper.scrollWidth) {
					wrapper.scrollLeft += ((wrapper.scrollWidth - wrapper.offsetWidth) / 100) * 20;
				}
			});
		}
	});
};

initResponsiveTables();
window.addEventListener('resize', initResponsiveTables);
